import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import connect from 'app/libs/connect';
import {
  metaTitle,
  metaDescription,
} from 'app/features/landing/meta/selectors';

const UI = ({ metaTitle, metaDescription }) => (
  <Helmet>
    <meta name="title" content={metaTitle} />
    <meta name="description" content={metaDescription} />
    <link rel="canonical" href="https://www.crunchyroll.com" />
  </Helmet>
);

UI.propTypes = {
  metaTitle: PropTypes.string.isRequired,
  metaDescription: PropTypes.string.isRequired,
};

UI.displayName = 'Meta';

const state = { metaTitle, metaDescription };

const Meta = connect(state)(UI);

export { UI };

export default Meta;
